//  #####  ##  ##      #####            ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  #####  ##  ##      #####  ########  ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  ##     ##  ######  #####             #####   ##
/*
<div class="manualFile flex vcenter">
    <label class="manualFile__frame flex vcenter">
        <input id="js-manualFile--entry" class="js-manualFile manualFile__input" data-target="entry" type="file" name="entry_file" />
        <div class="manualFile__btn flex vcenter hcenter">ファイル選択</div>
        <div class="js-manualFile-out--entry manualFile__text" data-def="5MB以内のPDFファイルをアップロードしてください。">
            5MB以内のPDFファイルをアップロードしてください。
        </div>
    </label>
    <button type="button" class="js-manualFile-toggle--entry js-manualFile-del manualFile__del" data-target="entry">×クリア</button>
</div>
<input id="js-manualFile-name--entry" type="text" class="js-manualFile-trace is-none" name="doc" data-target="entry">
*/
// ファイルアップロードUIのカスタム
const manualFileUpload = document.getElementsByClassName('js-manualFile')
const manualFileNameTrace = document.getElementsByClassName('js-manualFile-trace')
if (manualFileUpload[0]) {
  window.addEventListener('change', function (e) {
    fileUpSet(e.target)
  })
  window.addEventListener('click', function (e) {
    fileUpDel(e.target)
  })
}

function fileUpSet(item) {
  if (!item.classList.contains('js-manualFile')) {
    return
  }

  const file = item.files[0] // ファイルを取得
  const target = item.dataset.target // 各種反映先のスラッグ
  const fileType = item.dataset.fileType // 許可するファイルタイプ

  const fileSizeLimit = 5 // サイズ上限（MB）
  const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
  const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
  const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

  // 表示するテキスト
  let fileText = file.name + ' (' + fileSizeView + ')'
  // エラー判定
  let isError = false

  // サイズバリデーション
  if (file.size > fileSizeLimit * (1024 * 1024)) {
    isError = true
    item.value = '' // 入力を削除
    fileText =
      '<span style="color:red">ファイルサイズは' +
      fileSizeLimit +
      'MB以下にしてください (' +
      fileSizeLimit +
      ')。</span>'
  }
  // 拡張子バリデーション　実際の中身ではなく、ファイル名だけを見る簡単なもの
  if (fileType !== '') {
    const fileTypeList = fileType.split(',') // ,区切りで配列に変換
    if (!checkExt(file.name, fileTypeList)) {
      isError = true
      item.value = '' // 入力を削除
      fileText = '<span style="color:red">' + fileTypeList + 'ファイルのみがアップロードできます。</span>'
    }
  }

  // ファイル名やエラーを表示させる
  const fileTextTarget = document.getElementsByClassName('js-manualFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileText
  }

  // ファイル名を送信させる
  const fineNameTarget = document.getElementById('js-manualFile-name--' + target)
  if (fineNameTarget) {
    if (!isError) {
      fineNameTarget.value = file.name
    } else {
      fineNameTarget.value = ''
    }
  }

  // 切り替わる要素を反映させる
  const fineDelTarget = document.getElementsByClassName('js-manualFile-toggle--' + target)
  if (fineDelTarget[0]) {
    if (!isError) {
      for (const iterator of fineDelTarget) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of fineDelTarget) {
        iterator.classList.remove('active')
      }
    }
  }

  // 文字列から拡張子を返す
  function getExt(fileName) {
    const pos = fileName.lastIndexOf('.')
    if (pos === -1) return ''
    return fileName.slice(pos + 1)
  }
  // 拡張子を検証する
  function checkExt(fileName, exts) {
    // 比較のため小文字にする
    const ext = getExt(fileName).toLowerCase()
    // 許可する拡張子の一覧extsから対象の拡張子があるか確認する
    if (exts.indexOf(ext) === -1) {
      return false
    }
    return true
  }
}
function fileUpDel(item) {
  if (!item.classList.contains('js-manualFile-del')) {
    return
  }

  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイルを消す
  document.getElementById('js-manualFile--' + target).value = ''

  // 送信するファイル名を消す
  const fineNameTarget = document.getElementById('js-manualFile-name--' + target)
  if (fineNameTarget) {
    fineNameTarget.value = ''
  }

  // 切り替わる要素を消す
  const fineDelTarget = document.getElementsByClassName('js-manualFile-toggle--' + target)
  if (fineDelTarget[0]) {
    for (const iterator of fineDelTarget) {
      iterator.classList.remove('active')
    }
  }

  // テキスト表示欄をリセットする
  const fileTextTarget = document.getElementsByClassName('js-manualFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileTextTarget[index].dataset.def
  }
}
